import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";

/**
 * Discrete selector for session type.
 *
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").SessionType} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").SessionType) => void} props.onChange
 * @param {string} [props.helperText]
 * @param {string} [props.title]
 */
export const SessionTypeSelect = ({ value, onChange, helperText, title = "Session Type" }) => {
  const onChangeHandler = async (event) => {
    onChange(/** @type {any} */ (event.target.value));
  };

  return (
    <FormControl sx={{ width: "100%" }} margin="normal">
      <InputLabel id="session-type-label">{title}</InputLabel>
      <Select
        labelId="session-type-label"
        id="session-type"
        value={value}
        onChange={onChangeHandler}
        label={title}
        input={<OutlinedInput label={title} />}
      >
        <MenuItem value="Pitching">Pitching</MenuItem>
        <MenuItem value="PlayTesting">Play Testing</MenuItem>
        <MenuItem value="Demo">Demoing</MenuItem>
        <MenuItem value="Talk">Talk / Presentation</MenuItem>
        <MenuItem value="Other">Other</MenuItem>
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};
